import { getNormalizedCompanyName } from "./mappingHelper";

export function getS3Keys(demoConfiguration) {
  const { reportFiles } = demoConfiguration;
  if (reportFiles) {
    const keys = new Array(reportFiles.length);

    for (let i = 0; i < reportFiles.length; i++) {
      keys[i] = generateS3Key(reportFiles[i].name, demoConfiguration);
    }

    return keys.join(";");
  }

  return "";
}

export function generateS3Key(fileName, demoConfiguration) {
  return `DemoFiles/${getNormalizedCompanyName(demoConfiguration)}_${fileName}`;
}
